/* eslint-disable indent */
import Swiper from 'swiper/bundle';
//import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

$(function () {
	var swiper = new Swiper("#main-carousel", {
		direction: "vertical",
		threshold: (window.innerWidth <= 768 ? 1 : 5),
		parallax: true,
		speed: (window.innerWidth <= 768 ? 1000 : 1000),
		touchReleaseOnEdges: true,
		mousewheel: {
			enabled: true,
			//sensitivity: 0,
			releaseOnEdges: false,
			//thresholdTime: 1000,
			noMousewheelClass: "no-mousewheel"
			//thresholdDelta: 1
		},
		pagination: {
			enabled: false,
			//el: ".swiper-pagination",
			//clickable: true, 
		},
		on: {
			init: function () {
				console.log(this.mousewheel)
			}
		}
	});

	swiper.on("slideChange", function () {
		if(this.realIndex == ($(this.slides).length -1)) {
			$(this.slides).last().addClass("no-mousewheel")
		}else {
			$(this.slides).last().removeClass("no-mousewheel")
		}
	}) 

	const slides = $("#main-carousel .swiper-slide");
	if (slides.length) {
		slides[slides.length - 1].addEventListener('wheel', function (event) {
			if (event.deltaY < 0) {
				console.log('scrolling up');
				swiper.slidePrev()
			}
			else if (event.deltaY > 0) {
				console.log('scrolling down');
			}
		});

		//const mainImages = document.querySelectorAll(".main-caorousel-image");
		//for (let ii = 0; ii < mainImages.length; ii++) {
		//	mainImages[ii].addEventListener('wheel', function (event) {
		//		if (event.deltaY < 0) {
		//			console.log('scrolling up');
		//			event.preventDefault();
		//			swiper.slidePrev()
		//			//if (swiper.activeIndex < swiper.slides.length && isElementInViewport(mainImage)) return true;
		//		}
		//		else if (event.deltaY > 0) {
		//			console.log('scrolling down');
		//			if (swiper.activeIndex >= swiper.slides.length - 1 && isElementInViewport(mainImages[ii])) return true;
		//			event.preventDefault();

		//			swiper.slideNext()
		//		}
		//	});
		//}
		
	}

	function isElementInViewport(el) {

		if (typeof jQuery === "function" && el instanceof jQuery) {
			el = el[0];
		}

		var rect = el.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
			rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
		);
	}
})

$(function () {
	var swiper = new Swiper("#passione-carousel .swiper", {
		//parallax: true,
		threshold: (window.innerWidth <= 768 ? 1 : 5),
		speed: (window.innerWidth <= 768 ? 300 : 1000),
		navigation: {
			nextEl: '.passione-swiper-next',
			prevEl: '.passione-swiper-prev',
		},
		grabCursor: true,
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: false,
				translate: ["-120%", 0, -400],
				//scale: 0.5
			},
			next: {
				shadow: false,
				translate: ["120%", 0, -400],
				//scale: 1.5
			},
		},

	});
})


$(function () {
	var swiper = new Swiper("#news-carousel .swiper", {
		//parallax: true,
		slidesPerView: 1,
		spaceBetween: 0,
		slidesPerGroup: 1,
		navigation: {
			enabled: false,
			nextEl: '.passione-swiper-next',
			prevEl: '.passione-swiper-prev',
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			//dynamicBullets: true
		},
		breakpoints: {
			// when window width is >= 320px
			600: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			// when window width is >= 480px
			1000: {
				slidesPerView: 3,
				spaceBetween: 100,
			},
			
		}
	});
})



